<!--
 * @Author:
 * @LastEditTime: 2023-07-28
 * @Description: 危险辨识清单
-->
<template>
  <el-card class="h-full relative" id="risk-identfy-list">
    <el-tabs v-model="activeName">
      <el-tab-pane label="设备设施清单" name="equipmentList">
        <risk-equip-table v-if="activeName === 'equipmentList'"></risk-equip-table>
      </el-tab-pane>
      <el-tab-pane label="作业活动清单" name="jobList">
        <risk-job-table v-if="activeName === 'jobList'"></risk-job-table>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import RiskEquipTable from '../components/RiskEvaluateListTable/RiskEquipTable'
import RiskJobTable from '../components/RiskEvaluateListTable/RiskJobTable'

export default {
  name: 'risk-evaluate-list',
  components: {
    RiskEquipTable,
    RiskJobTable,
  },
  created() {
    // tagType 1为设备设施 2为作业活动 3为基础管理
    this.activeName =
      this.$route.query.tagType && this.$route.query.tagType == 2 ? 'jobList' : 'equipmentList'
  },
  data() {
    return {
      activeName: 'equipmentList',
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-tabs {
  height: 100%;
}
::v-deep .el-tabs__content {
  height: calc(100% - 54px) !important;
  position: inherit;
  .el-tab-pane {
    height: 100%;
  }
}
</style>
